/**
 * components/riskTerminal/heldChips.js
 *
 * upstox-076 / 084 — the watchlist chain's held-quantity chips, ONE function for both layouts (the phone chain and, since
 * upstox-084, the desktop watchlist). For the account on screen: the net signed quantity of every contract it holds,
 * over today's groups, HOLDINGS (the HOLDING groups, outside the book and the limit) and unclassified legs — every open leg
 * the panel lists; rows at net quantity 0 (CLOSED TODAY) hold nothing. Nothing for a contract not held.
 */

import { qtyText } from './model';

const heldKey = (u, exp, strike, type) => [u, exp || '', Number(strike), type].join('|');

/** net quantity per contract, over every leg this account holds (today's groups, holdings, unclassified) */
export function heldIndex(panel) {
  const idx = {};
  const add = l => {
    if (!l || l.quantity == null || !l.underlying || l.strike == null || !l.option_type) return;
    const k = heldKey(l.underlying, l.expiry, l.strike, l.option_type);
    idx[k] = (idx[k] || 0) + l.quantity;
  };
  ((panel && panel.structures && panel.structures.items) || []).forEach(s => (s.legs || []).forEach(add));
  ((panel && panel.holdings && panel.holdings.items) || []).forEach(s => (s.legs || []).forEach(add));
  ((panel && panel.unclassified && panel.unclassified.items) || []).forEach(add);
  return idx;
}

/** "+65" / "−130" where this account holds the contract of that chain row, else null */
export function heldChip(idx, list, strike, side) {
  const u = list && list.rule && list.rule.underlying;
  if (!u || !idx) return null;
  const q = idx[heldKey(u, list.expiry, strike, side)];
  return q ? qtyText(q) : null;
}
